/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface TextSnippetTag { 
    readonly id: number;
    readonly name: string;
}
export const TextSnippetTag_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetTag_name_Validators: ValidatorFn[] =
    [  Validators.required, ];


